import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "slide"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header" }, "Verification Code", -1 /* HOISTED */)
const _hoisted_3 = { class: "slide-content" }
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "input-body" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = {
  key: 1,
  class: "hint"
}
const _hoisted_9 = {
  key: 0,
  class: "button-container"
}
const _hoisted_10 = {
  key: 0,
  class: "slide"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header" }, "Sign Up", -1 /* HOISTED */)
const _hoisted_12 = { class: "slide-content" }
const _hoisted_13 = { class: "main-content full-content" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Looks like you dont have an Opt Account. Enter your details below.")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "input-boxes signup" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "terms-check" }
const _hoisted_18 = { class: "checkbox" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "flex-label",
  for: "checkbox"
}, [
  /*#__PURE__*/_createTextVNode("By signing up I agree to the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com" }, "terms of service"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com" }, "privacy policy")
], -1 /* HOISTED */)
const _hoisted_20 = { class: "opt-assurance" }
const _hoisted_21 = {
  key: 0,
  class: "error"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://www.google.com"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Why do I need an Opt Account?")
], -1 /* HOISTED */)
const _hoisted_23 = { class: "button-container" }
const _hoisted_24 = {
  key: 0,
  class: "slide"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header" }, "Verification", -1 /* HOISTED */)
const _hoisted_26 = { class: "slide-content" }
const _hoisted_27 = { class: "main-content" }
const _hoisted_28 = { class: "input-boxes verification" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "Enter your details below to sign in or sign up", -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "dialogue" }, "Send Verification Code to: ", -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "error flex-center"
}
const _hoisted_32 = { class: "verification-method flex-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  class: "link why-link",
  href: "https://www.google.com"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Why am I being asked for this?")
], -1 /* HOISTED */)
const _hoisted_34 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mini-auth-container", {'no-scroll': $setup.noScroll}])
  }, [
    _createVNode(_Transition, {
      onBeforeEnter: _cache[3] || (_cache[3] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => ($setup.noScroll = false)),
      appear: ""
    }, {
      default: _withCtx(() => [
        ($setup.stage == $setup.LoginStage.CODE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(" Please check your " + _toDisplayString($setup.verificationSelection === $setup.email ? 'email' : 'text messages') + " for the 5 digit code we sent you. If you did not receive it, ", 1 /* TEXT */),
                      _createElementVNode("a", { onClick: $setup.doSendCode }, "click to resend here.")
                    ]),
                    ($setup.errorMsg)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode($setup["VCodeInput"], {
                      modelValue: $setup.inputCode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputCode) = $event)),
                      length: 5
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    ($setup.isDevEnvironment && $setup.DEV_code)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "DEV HINT: Your code is " + _toDisplayString($setup.DEV_code), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              (!$props.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "borderless back",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => { $setup.DEV_code = null; $setup.errorMsg = null; $setup.stage = $setup.LoginStage.VERIFICATION})
                    }, "Back"),
                    _createElementVNode("button", {
                      class: "borderless",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.doCodeSubmission($setup.inputCode)))
                    }, "Submit Code")
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[11] || (_cache[11] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[12] || (_cache[12] = ($event: any) => ($setup.noScroll = false)),
      appear: ""
    }, {
      default: _withCtx(() => [
        ($setup.stage == $setup.LoginStage.SIGNUP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode($setup["vtextfield"], {
                      class: "text u-info",
                      label: "First Name",
                      modelValue: $setup.firstName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.firstName) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createVNode($setup["vtextfield"], {
                      class: "text u-info",
                      label: "Last Name",
                      modelValue: $setup.lastName,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.lastName) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createVNode($setup["vtextfield"], {
                      class: "text u-info",
                      label: "Email",
                      modelValue: $setup.email,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.email) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createVNode($setup["VPhoneInput"], {
                      class: "phone u-info",
                      label: "Phone Number",
                      modelValue: $setup.phone,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.phone) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    ($setup.env == 'development')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_16, "Real number or 555-555-0100 to 0199"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode($setup["VCheckbox"], {
                        modelValue: $setup.acceptedTerms,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.acceptedTerms) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _hoisted_19
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    ($setup.errorMsg)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _hoisted_22
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "borderless back",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {$setup.stage = $setup.LoginStage.VERIFICATION; $setup.errorMsg = null})
                }, "Back"),
                _createElementVNode("button", {
                  class: "primary",
                  onClick: $setup.createAccount
                }, "Create Account")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, {
      onBeforeEnter: _cache[18] || (_cache[18] = ($event: any) => ($setup.noScroll = true)),
      onAfterLeave: _cache[19] || (_cache[19] = ($event: any) => ($setup.noScroll = false)),
      appear: ""
    }, {
      default: _withCtx(() => [
        ($setup.stage == $setup.LoginStage.VERIFICATION)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _hoisted_30,
                    ($setup.verificationSelection === 'email')
                      ? (_openBlock(), _createBlock($setup["vtextfield"], {
                          key: 0,
                          class: "text u-info",
                          label: "Email",
                          modelValue: $setup.email,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.email) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"]))
                      : ($setup.verificationSelection === 'phone')
                        ? (_openBlock(), _createBlock($setup["VPhoneInput"], {
                            key: 1,
                            class: "phone u-info",
                            label: "Phone Number",
                            modelValue: $setup.phone,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.phone) = $event))
                          }, null, 8 /* PROPS */, ["modelValue"]))
                        : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.errorMsg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_32, [
                    ($setup.verificationSelection == 'phone')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "change-method",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.verificationSelection = 'email'))
                        }, "Verify with an email address instead"))
                      : _createCommentVNode("v-if", true),
                    ($setup.verificationSelection == 'email')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "change-method",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.verificationSelection = 'phone'))
                        }, "Verify with an phone number instead"))
                      : _createCommentVNode("v-if", true),
                    _hoisted_33
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "borderless back",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.emit('previous')))
                }, "Back"),
                _createElementVNode("button", {
                  class: "borderless",
                  onClick: $setup.doSendCode
                }, "Next")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 2 /* CLASS */))
}